import React from "react";
// import sections
import HomeBlock from "../components/sections/HomeBlock";

const Home = () => {
  return (
        <HomeBlock topDivider />
  );
};

export default Home;
